import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ICardUI } from 'src/app/api/interfaces/card.interface';
import { ICard } from 'src/app/modules/main-game/interfaces/main';
import { IRestoreBoostingCharacterCards } from '../../modals/energy-restoring/energy-restoring.component';

@Component({
  selector: 'app-restore-bossting-card-list',
  templateUrl: './restore-bossting-card-list.component.html',
  styleUrls: ['./restore-bossting-card-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RestoreBosstingCardListComponent implements OnInit {
  public craftCard: ICard = {
    isPromoCards: false,
    rarity: 'MASTERPIECE',
    name: 'basmati rice',
    element:
      'assets/main-game/game-cards/resource-cards-elements/Elements/BasmatiRice.png',
    effect:
      'assets/main-game/game-cards/resource-cards-elements/Effects/BasmatiRice.png',
    grade: 'assets/main-game/game-cards/resource-cards-elements/Grade/1.png',
  };
  @Input() cards: IRestoreBoostingCharacterCards[] = [];
  @Output() useCard: EventEmitter<{ cardId: number; count: number }> =
    new EventEmitter<{ cardId: number; count: number }>();
  constructor() {}

  ngOnInit(): void {
    console.log(this.cards);
  }

  public takeCard(card: IRestoreBoostingCharacterCards): void {
    if (card.count > 0) {
      this.useCard.emit({ cardId: card.apiCard.id, count: card.count });
    }
  }
}
